import classes from './buttonWithChangeState.module.scss';

function ButtonWithChangeState(props) {
  const { isOpen, openImg, closeImg, changeStateHandler, children, label } = props;

  return (
    <div className="w-full d-flex flex-column align-items-center justify-content-center">
      <button
        className={`${classes.btnContainer} p-1 py-3 mb-3 w-75 w-sm-50 align-items-center`}
        onClick={changeStateHandler}
      >
        <img data-testid="image" src={isOpen ? openImg : closeImg} alt="state" className="mb-3" />
        <br />
        {label}
      </button>
      {isOpen && children}
    </div>
  );
}

export default ButtonWithChangeState;
